import { useExperimentTreatment } from '@ms/yammer-experiments-context';

export const useIsLeftNavCollapseEnabled = (): boolean => useExperimentTreatment('EngageIASimplificationNavRefresh');
